import React, { useState } from "react";
import TimelineSort from "components/TimelineSort";
import "assets/scss/helpers/filter.scss";
import TimelineFilter from "components/TimelineFilter";

export default () => {
  const [sortName, setSortName] = useState("Recent");
  return (
    <div className="filterRoot">
      <div className="feedText">{sortName} Feeds</div>
      <div className="filterOptions">
        <TimelineSort setSortName={setSortName} />
        <TimelineFilter />
      </div>
    </div>
  );
};
